import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { generateSEOMeta, generateSchemaOrg } from '@/components/base/SEOData';

export default function Home() {
  useEffect(() => {
    const seoMeta = generateSEOMeta({
      title: '首页',
      description: '膀胱健康知识网——专注泌尿健康科普，提供科学的膀胱保健知识、盆底肌训练方法、饮食调理建议和日常保健指导，帮助您守护膀胱健康，提升生活品质。',
      keywords: '膀胱健康,泌尿健康,盆底肌训练,膀胱保健,尿频,尿失禁,健康科普',
      canonicalUrl: '/',
      ogType: 'website',
      ogImage: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20wellness%20health%20concept%20with%20soft%20cream%20and%20golden%20tones%2C%20minimalist%20medical%20aesthetic%2C%20clean%20and%20calm&width=1200&height=630&seq=og-home&orientation=landscape',
    });

    const schema = generateSchemaOrg({
      '@type': 'WebSite',
      name: '膀胱健康知识网',
      url: 'https://bladder-health.example.com',
      description: '专注泌尿健康科普，提供科学的膀胱保健知识和训练方法',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://bladder-health.example.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    });

    const existingMeta = document.querySelector('script[data-seo-meta]');
    if (existingMeta) existingMeta.remove();
    const metaScript = document.createElement('script');
    metaScript.setAttribute('data-seo-meta', 'true');
    metaScript.type = 'application/json';
    metaScript.textContent = seoMeta;
    document.head.appendChild(metaScript);

    const existingSchema = document.querySelector('script[data-schema-org]');
    if (existingSchema) existingSchema.remove();
    const schemaScript = document.createElement('script');
    schemaScript.setAttribute('data-schema-org', 'true');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = schema;
    document.head.appendChild(schemaScript);

    document.title = '膀胱健康知识网 - 科学膀胱保健与泌尿健康科普平台';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '膀胱健康知识网——专注泌尿健康科普，提供科学的膀胱保健知识、盆底肌训练方法、饮食调理建议和日常保健指导，帮助您守护膀胱健康，提升生活品质。');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'description';
      newMeta.content = '膀胱健康知识网——专注泌尿健康科普，提供科学的膀胱保健知识、盆底肌训练方法、饮食调理建议和日常保健指导，帮助您守护膀胱健康，提升生活品质。';
      document.head.appendChild(newMeta);
    }

    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) {
      metaKw.setAttribute('content', '膀胱健康,泌尿健康,盆底肌训练,膀胱保健,尿频,尿失禁,健康科普');
    } else {
      const newKw = document.createElement('meta');
      newKw.name = 'keywords';
      newKw.content = '膀胱健康,泌尿健康,盆底肌训练,膀胱保健,尿频,尿失禁,健康科普';
      document.head.appendChild(newKw);
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://bladder-health.example.com/');
    } else {
      const newCanonical = document.createElement('link');
      newCanonical.rel = 'canonical';
      newCanonical.href = 'https://bladder-health.example.com/';
      document.head.appendChild(newCanonical);
    }
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <article>
          <HeroSection />
        </article>
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}